var _createClass = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/classCallCheck.js");

/*
  An npm JavaScript library for integrating mutable data with SLP tokens.

*/

/* eslint-disable no-async-promise-executor */
// Local libraries
var Create = require('./lib/create');

var Get = require('./lib/get');

var FilecoinData = require('./lib/filecoin-data');

var Data = require('./lib/data');

var SlpMutableData = /*#__PURE__*/function () {
  "use strict";

  function SlpMutableData() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SlpMutableData);

    // Dependency injection
    this.wallet = localConfig.wallet;

    if (!this.wallet) {
      throw new Error('Instance of minimal-slp-wallet must be passed as wallet when instantiating this library.');
    } // Instantiate the support libraries.


    this.create = new Create(localConfig);
    this.get = new Get(localConfig);
    this.data = new Data(localConfig);
  }

  return _createClass(SlpMutableData);
}();

module.exports = {
  SlpMutableData: SlpMutableData,
  FilecoinData: FilecoinData
};